import { Reducer } from 'redux';

import { ThunkAnyAction } from '../../services/apiMiddleware';

import { ObjectivesResp, ObjectiveItem, SubObjectiveItem } from './interfaces';
import {
  getObjectivesAT,
  getObjectiveActions,
  postObjectiveActions,
  updateObjectiveActions,
  getSubobjectivesActions,
  deleteSubobjectiveActions,
  postSubobjectiveActions,
  clearObjectiveActionHack,
} from './actionTypes';

export interface OkrsSessionState {
  loadingObjectives: boolean;
  loadingCreation: boolean;
  objectivesListData?: ObjectivesResp;
  loadingSingle: boolean;
  objectiveDetails?: ObjectiveItem;
  subobjectives: Record<string, { isLoading: boolean; objectives?: SubObjectiveItem[]; error?: object }>;
}

export function getInitialOkrsSessionState(): OkrsSessionState {
  return {
    loadingObjectives: false,
    loadingCreation: false,
    loadingSingle: false,
    subobjectives: {},
  };
}

const updateObjective = (state: OkrsSessionState, action: ThunkAnyAction) => {
  const editedObjective = action.response.data;
  const newState = clearObjectiveState(state, editedObjective.id);
  newState.objectiveDetails = editedObjective;
  return newState;
};

function clearObjectiveState(state: OkrsSessionState, objectiveId: string): OkrsSessionState {
  const newState = { ...state };

  delete newState.subobjectives[objectiveId];
  delete newState.objectivesListData;
  if (newState.objectiveDetails && newState.objectiveDetails.id === objectiveId) {
    delete newState.objectiveDetails;
  }

  return newState;
}

const objectiveReducer: Reducer<OkrsSessionState, ThunkAnyAction> = (
  state: OkrsSessionState = getInitialOkrsSessionState(),
  action: ThunkAnyAction,
): OkrsSessionState => {
  switch (action.type) {
    case getObjectivesAT.Request:
      return { ...state, loadingObjectives: true };
    case getObjectivesAT.Success:
      return { ...state, loadingObjectives: false, objectivesListData: action.response.data };
    case getObjectivesAT.Failed:
      return { ...state, loadingObjectives: false };

    case postObjectiveActions.Request:
      return { ...state, loadingCreation: true };
    case postObjectiveActions.Success:
      return { ...state, loadingCreation: false };
    case postObjectiveActions.Failed:
      return { ...state, loadingCreation: false };

    case getObjectiveActions.Request:
      return { ...state, loadingSingle: true };
    case getObjectiveActions.Success:
      return { ...state, loadingSingle: false, objectiveDetails: action.response.data };
    case getObjectiveActions.Failed:
      return { ...state, loadingSingle: false };

    case updateObjectiveActions.Success:
      return updateObjective(state, action);

    case getSubobjectivesActions.Request:
      if (!state.subobjectives[action.superobjectiveId]) {
        state.subobjectives[action.superobjectiveId] = { isLoading: true };
      } else {
        state.subobjectives[action.superobjectiveId].isLoading = true;
      }
      return state;
    case getSubobjectivesActions.Failed:
      state.subobjectives[action.superobjectiveId] = {
        isLoading: false,
        error: action.error && action.error.message,
      };
      return state;
    case getSubobjectivesActions.Success:
      state.subobjectives[action.superobjectiveId] = {
        isLoading: false,
        objectives: action.response.data.sub_objectives,
      };
      return state;

    case clearObjectiveActionHack:
    case deleteSubobjectiveActions.Success:
    case postSubobjectiveActions.Success:
      return clearObjectiveState(state, action.superobjectiveId);

    default:
      return state;
  }
};

export default objectiveReducer;
